module.exports = __webpack_public_path__ + "static/img/user-comment4.4475378.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment4.png
// module id = idH+
// module chunks = 0